const users = [
  {
    _id: 'demo-user-1',
    name: 'Alex Rivera',
    bio: 'Curating rare digital fashion pieces and luxury collectibles.',
    wallet: '0x742d35cc6634c0532925a3b844bc9e7595f0beb0',
    avatar: '/demo/avatar-2.png',
    spent: 142500,
    received: 218900,
    isVerified: true,
    customURL: 'https://twitter.com',
    createdAt: '2024-11-12T10:00:00.000Z',
  },
  {
    _id: 'demo-user-2',
    name: 'Mina Park',
    bio: 'NFT artist focused on handcrafted accessories and timeless design.',
    wallet: '0x8ba1f109551bd432803011645ac136c64c8c3b2',
    avatar: '/demo/girl.png',
    spent: 98500,
    received: 176400,
    isVerified: true,
    createdAt: '2024-10-05T14:30:00.000Z',
  },
  {
    _id: 'demo-user-3',
    name: 'Jordan Cole',
    bio: 'Collector of premium watches and limited-edition drops.',
    wallet: '0x3c44cdddb6a900fa2b585dd299e03d12fa4293bc',
    avatar: '/demo/boy.png',
    spent: 203750,
    received: 94500,
    isVerified: false,
    createdAt: '2024-09-18T09:15:00.000Z',
  },
  {
    _id: 'demo-user-4',
    name: 'Sofia Laurent',
    bio: 'Building a gallery of iconic bags and wearable art.',
    wallet: '0x90f79bf6eb2c4f870365e785982e1f101e93b906',
    avatar: '/demo/avatar-1.png',
    spent: 167200,
    received: 132800,
    isVerified: true,
    createdAt: '2024-08-22T16:45:00.000Z',
  },
  {
    _id: 'demo-user-5',
    name: 'Ethan Brooks',
    bio: 'Early adopter trading high-value collectibles on Club Rare.',
    wallet: '0x15d34aaf54267db7d7c367839aaf71a00a2c6a65',
    avatar: '/demo/avatar-2.png',
    spent: 89000,
    received: 156300,
    isVerified: false,
    createdAt: '2024-07-30T11:20:00.000Z',
  },
  {
    _id: 'demo-user-6',
    name: 'Yuki Tanaka',
    bio: 'Exploring the intersection of nature photography and NFTs.',
    wallet: '0x9965507d947a3257c7e11236d1a60f5825c4d0',
    avatar: '/demo/girl.png',
    spent: 75400,
    received: 112600,
    isVerified: true,
    createdAt: '2024-06-14T08:00:00.000Z',
  },
  {
    _id: 'demo-user-7',
    name: 'Noah Bennett',
    bio: 'Reselling verified luxury tokens to a global audience.',
    wallet: '0x976ea74026e726554db657fa54763abd0c3a256a',
    avatar: '/demo/boy.png',
    spent: 118900,
    received: 198400,
    isVerified: true,
    createdAt: '2024-05-02T13:10:00.000Z',
  },
  {
    _id: 'demo-user-8',
    name: 'Lena Vogt',
    bio: 'Passionate about supporting emerging creators on-chain.',
    wallet: '0x14d7999643508cda6bfd0848e0d344a76a16373',
    avatar: '/demo/avatar-1.png',
    spent: 62300,
    received: 87400,
    isVerified: false,
    createdAt: '2024-04-19T17:55:00.000Z',
  },
];

export default users;

export const usersById = users.reduce((acc, user) => {
  acc[user._id] = user;
  return acc;
}, {});

export const usersByWallet = users.reduce((acc, user) => {
  acc[user.wallet.toLowerCase()] = user;
  return acc;
}, {});
